import en from '../en/search'

const cz: typeof en = {
  header: 'Vyhledávání',
  filter: 'Filtrovat',
  filter_results: 'Filtrování výsledku',
  no_options: 'Žádné možnosti',
  year: 'Rok',
  author: 'Kdo',
  author_search: 'Vyhledej osobu',
  place: 'Kde',
  place_search: 'Vyhledej místo',
  publishing_place_search: 'Vyhledej místo vydání',
  what: 'Co',
  object_search: 'Vyhledej',
  iiif_format: 'Dostupné v IIIF formátu',
  books: 'Knihy',
  illustrations: 'Ilustrace',
  book_name: 'Název (Knihy) A-Z',
  category: 'Vybrat kategorii',
  search: 'Vyhledávat',
  cancel_search: 'Zrušit vyhledávání',
  search_expression: 'Vyhledejte výraz...',
  records_count: 'Počet záznamů: ',
  record_id: 'ID záznamu',
  number_of_illustrations_in_publication: 'počet ilustrací v publikaci',
  from: 'Od',
  to: 'Do',
  all: 'Vše',
  main_author: 'Autor',
  title: 'Název',
  publishing_place: 'Místo vydání',
  printer_publisher: 'Tiskař/nakladatel',
  publishing_year: 'Rok vydání',
  delete: 'Smazat',
  add: 'Přidat další',
  oldest: 'Nejstarší',
  newest: 'Nejnovější',
  person: 'vyobrazeno',
  keyword: 'vedlejší motiv',
  theme: 'hlavní motiv',
  login_required_for_selection: 'Pro použití Mého výběru se přihlaste',
}

export default cz
